import Entity from "./Entity";

export default class MapObject extends Entity {
    static PoiType = {
        NORMAL: "normal",
        EMERGENCY: "emergency",
        TERRAIN_REPORT: "terrain_report"
    }

    constructor(data) {
        super(data)

        this.landmarks = [];
        if (data["landmarks"]) {
            for (const landmark in data["landmarks"]) {
                this.landmarks.push(landmark);
            }
        }

        this.attributeKeys.push("status");
    }

    get id() {
        return this.get("uid");
    }

    set id(value) {
        this.set("uid", value);
    }

    getId() {
        return this.get("uid");
    }

    getName() {
        return this.get("name");
    }

    getType() {
        return this.get("type");
    }

    getChildren() {
        const result = [];

        const jsonChildren = this.get("children");
        if (jsonChildren) {
            for (const jsonChild of jsonChildren) {
                result.push(new MapObject(jsonChild));
            }
        }

        return result;
    }

    toJSON() {
        const json = super.toJSON();

        if (this.landmarks) {
            json.landmarks = {};
            for (const landmark of this.landmarks) {
                if (landmark != "") {
                    json.landmarks[landmark] = true;
                }
            }
        }

        return json;
    }
}